import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #0077cc;
    --secondary-color: #ff4500;
    --background-light: #f8f9fa;
    --text-light: #212529;
    --background-dark: #212529;
    --text-dark: #f8f9fa;
    --card-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    --transition: all 0.3s ease;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;
    line-height: 1.6;
    transition: var(--transition);
    /* Oculta a barra de rolagem mas mantém a funcionalidade */
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }

  body::-webkit-scrollbar {
    display: none; /* Safari e Chrome */
  }

  body.light-theme {
    background-color: var(--background-light);
    color: var(--text-light);
  }

  body.dark-theme {
    background-color: var(--background-dark);
    color: var(--text-dark);
  }

  body.custom-theme {
    background-color: var(--custom-background-color) !important;
    color: var(--custom-font-color) !important;
    font-size: var(--custom-font-size) !important;
  }

  body.custom-theme * {
    color: inherit;
  }

  body.custom-theme .news-item,
  body.custom-theme .news-card,
  body.custom-theme .header {
    background-color: var(--custom-background-color);
    color: var(--custom-font-color);
  }

  body.custom-theme .news-item h3,
  body.custom-theme .news-card h3,
  body.custom-theme .news-item p,
  body.custom-theme .news-card p {
    color: var(--custom-font-color);
  }

  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: var(--transition);
  }

  a:hover {
    color: var(--secondary-color);
  }

  button {
    cursor: pointer;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 14px;
    transition: var(--transition);
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    font-size: 18px;
  }

  .error {
    color: #dc3545;
    text-align: center;
    padding: 20px;
    border: 1px solid #dc3545;
    border-radius: 4px;
    margin: 20px 0;
  }
`;